import { Component, OnInit, ChangeDetectorRef, HostListener, Host, ViewChild  } from '@angular/core';
import { MainService } from './services/main/main.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { AuthService } from '../app/services/auth/auth.service';
import colorJson from './colors.json';
import { LoaderService, LoaderState } from './services/interceptor/loader.service';
import { Event as RouterEvent, NavigationEnd, NavigationStart } from '@angular/router';
import { Router } from '@angular/router';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs/operators';
import { RouteConfigLoadEnd } from '@angular/router';
import { RouteConfigLoadStart } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
// import { Intercom } from 'ng-intercom';
import { domain } from 'process';
import { SimpleDialogComponent } from 'src/app/shared/simple-dialog/simple-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { getUserProfiles } from 'src/app/core/session';
declare var Intercom: any;

declare global {
  interface Window {
    gtranslateSettings: {
      default_language: string;
      detect_browser_language: boolean;
      languages: string[];
      wrapper_selector: string;
    };
  }
}
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  @ViewChild('envDropdownTarget', { static: false }) envDropdownTarget: any;

  title = 'enterprise-panel';
  colors: any = colorJson;
  show: any = false;
  public isShowingRouteLoadIndicator: boolean;
  private subscription: Subscription;
  shwoTopbar = 1;
  hideTopBar: any = localStorage.getItem('hideTopBar') ? Number(localStorage.getItem('hideTopBar')) : 0;
  domainLink = 'https://business.denefits.com/';
  buttonText: string = 'Schedule Training';

  envProd: boolean = true;
  envDemo: boolean = false;
  baseUrl: string = localStorage.getItem("baseUrl");
  envDropdown: boolean = false;
  envs: any = [
    { id: 1, name: 't1', url: "https://api.denefits.com/business/" },
    { id: 2, name: 't2', url: "https://api.denefits.com/business2/" },
    { id: 3, name: 't3', url: "https://api.denefits.com/business3/" },
    { id: 4, name: 't4', url: "https://api.denefits.com/business4/" },
    { id: 5, name: 't5', url: "https://api.denefits.com/business5/" },
    { id: 1, name: 'd1', url: "https://demoapi.denefits.com/business/" },
  ];
  currentEnv: any = this.envs[0];

  constructor(
    public mainService: MainService,
    public authService: AuthService,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    public router: Router,
    public loaderService: LoaderService,
    private cd: ChangeDetectorRef,
    private titleService: Title,
    // private intercom: Intercom,
    public dialog: MatDialog,
    private swUpdate: SwUpdate
  ) {
    this.watchForAppUpdates();
    this.envProd = environment.production;
    this.envDemo = environment.demo;
    mainService.init();

    var asyncLoadCount = 0;
    router.events.subscribe(
      (event: RouterEvent): void => {
        if (event instanceof RouteConfigLoadStart) {
          asyncLoadCount++;
        } else if (event instanceof RouteConfigLoadEnd) {
          asyncLoadCount--;
        }
        this.isShowingRouteLoadIndicator = !!asyncLoadCount;
        this.cd.detectChanges();

        if (event instanceof NavigationEnd) {
          Intercom('hide');
          this.setTitle(event);
        }
      }
    );

    iconRegistry
      .addSvgIcon('avatar', sanitizer.bypassSecurityTrustResourceUrl('assets/img/svg/avatar.svg'))
      .addSvgIcon('key', sanitizer.bypassSecurityTrustResourceUrl('assets/img/svg/key.svg'));
  }

  // When a new build is downloaded by the service worker, activate it and
  // reload on the next route change so users never sit on a stale build.
  private watchForAppUpdates() {
    if (!this.swUpdate.isEnabled) { return; }
    this.swUpdate.versionUpdates
      .pipe(filter((e): e is VersionReadyEvent => e.type === 'VERSION_READY'))
      .subscribe(() => {
        this.swUpdate.activateUpdate().then(() => {
          const sub = this.router.events
            .pipe(filter(e => e instanceof NavigationStart))
            .subscribe(() => { sub.unsubscribe(); document.location.reload(); });
        });
      });
  }

  ngOnInit() {
    const envId = localStorage.getItem("envId");
    if (envId) {
      this.currentEnv = this.envs.find((env: any) => env.id === Number(envId));
    }
    this.updateButtonText();
    this.initGtranslate();
    this.trackLanguageChange();
    if (environment.production) {
      console.log = function () { }
    }
    this.colors = {
      primary: colorJson.primary,
      accent: colorJson.accent,
      primaryGradient: colorJson.primaryGradient
    };

    this.authService.userProfileData$
      .subscribe((data: any) => {
        if (data && data[0] && data[0].theme_setting) {
          this.colors = JSON.parse(data[0].theme_setting);
          this.setTheme();
        }
      });

    if (localStorage.getItem('userProfileData')) {
      let userProfileData = getUserProfiles();
      if (userProfileData && userProfileData[0] && userProfileData[0].theme_setting && JSON.parse(userProfileData[0].theme_setting)) {
        this.colors = JSON.parse(userProfileData[0].theme_setting);
      }
      this.authService.userProfileData$.next(userProfileData);
    }

    this.setTheme();

    this.subscription = this.loaderService.loaderState.subscribe((state: LoaderState) => {
      this.show = state.show;
      this.cd.detectChanges();
    });
    const checkSession = sessionStorage.getItem('hideTopBar') ?  Number(sessionStorage.getItem('hideTopBar')) : 0;
    if (this.hideTopBar || checkSession) {
      this.shwoTopbar = 0;
    } else {
      // tslint:disable-next-line:max-line-length
      this.shwoTopbar = (window.location.href.includes('/app') || window.location.href.includes('/register') || window.location.href.includes('/login') || window.location.href == this.domainLink) ? 1 : 0;
    }


  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.updateButtonText();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.envDropdown && !this.envDropdownTarget.nativeElement.contains(event.target)) {
      this.envDropdown = false;
    }
  }

  updateButtonText() {
    let screenWidth = window.innerWidth;
    if (screenWidth >= 1501) {
      this.buttonText = 'Schedule Now';
    } else {
      this.buttonText = 'Schedule Training';
    }
  }

  onMouseOver() {
    this.buttonText = 'Schedule Now';
  }

  onMouseOut() {
    this.updateButtonText();
  }

  setTheme() {
    document.documentElement.style.setProperty('--d-primary', this.colors.primary);
    document.documentElement.style.setProperty('--d-accent', this.colors.accent);
    document.documentElement.style.setProperty('--primary-gradient', this.colors.primaryGradient);
    document.documentElement.style.setProperty('--primary-text', this.colors.primaryText);
    document.documentElement.style.setProperty('--accent-text', this.colors.accentText);
  }

  setTitle(event) {
    if (event && event.url) {
      let url = event.url;
      if (url == '/' || url.includes('login')) {
        this.titleService.setTitle(`Login to Your Business Panel - Denefits`);
      } else if (url.includes('register')) {
        this.titleService.setTitle(`Let's Get Your Business Registered - Denefits`);
      } else {
        this.titleService.setTitle(`Denefits Business`);
      }
    }
  }

  initGtranslate() {
    const gTranslateSettings = {
      default_language: 'en',
      native_language_names: true,
      detect_browser_language: true,
      languages: ['en', 'de', 'es', 'fr', 'it', 'ja', 'pl', 'zh-CN', 'zh-TW'],
      wrapper_selector: '.gtranslate_wrapper',
      alt_flags: { en: 'usa' }
    };
    const script = document.createElement('script');
    script.src = 'https://cdn.gtranslate.net/widgets/latest/float.js';
    script.defer = true;
    document.body.appendChild(script);
    window.gtranslateSettings = gTranslateSettings;
  }

  previousLanguage = "";
  trackLanguageChange() {
    let observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'lang') {
          let newLanguage = document.documentElement.getAttribute('lang');
          if (newLanguage !== 'auto' && this.previousLanguage !== newLanguage) {
            this.previousLanguage = newLanguage;
            let languageChangeEvent = new CustomEvent('languageChanged', {
              detail: { language: newLanguage }
            });
            window.dispatchEvent(languageChangeEvent);
          }
        }
      });
    });
    this.previousLanguage = document.documentElement.getAttribute('lang');
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['lang'] });
  }

  redirectToApp() {
    const [androidDeepLink, iosDeepLink] = [
      'https://play.google.com/store/apps/details?id=bhct.denefits.doctor&hl=en&gl=US',
      'https://apps.apple.com/in/app/denefits/id1253338581'
    ];
    const userAgent = navigator.userAgent || navigator.vendor;
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      setTimeout(() => {
        window.location.href = iosDeepLink; // Redirect to the App Store if the app is not installed
      }, 500);
    } else if (/android/i.test(userAgent)) {
      console.log('ereree0');
      setTimeout(() => {
        window.location.href = androidDeepLink; // Redirect to the Play Store if the app is not installed
      }, 500);
    } else {
      console.log('ereree');
    }
  }

  hideTopBarFun() {
    if (window.location.href.includes('/register') || window.location.href.includes('/login') || window.location.href == this.domainLink) {
      sessionStorage.setItem('hideTopBar', '1');
    } else {
      localStorage.setItem('hideTopBar' , '1');
    }
    this.shwoTopbar = 0;
  }


  openModal() {
    this.mainService.openTrainingModal();
  }

  changeEnv(envId: any) {
    const env = this.envs.find((env: any) => env.id === envId);
    if (env) {
      this.currentEnv = env;
      localStorage.setItem("envId", env.id);
      window.location.reload();
    }
  }
}
